import React, { lazy } from 'react';

const Indicator = lazy(() => import('./Indicator'));

const StageIndicator = () => {
    if (process.env.REACT_APP_ENV !== 'stage') {
        return null;
    }

    return (
        <Indicator />
    );
};

export default StageIndicator;
